<div class="document-attach px-4 py-2 ls1">

  <div (click)="isOpen = !isOpen"><ng-content></ng-content></div>
  <ul *ngIf="isOpen" class="doc-attach-menu" [ngClass]="{'set-left': position === 'left', 'set-right': position === 'right'}">

      <div class="document-container">

        <li class="document-list-item" *ngFor="let document of documents; trackBy: documentId">
          <label class="ls-checkbox"><!-- TODO ls-checkbox -->
            <input *ngIf="multiple" name="selectedDocuments" type="checkbox" [(ngModel)]="document.checked" [disabled]="document.scanStatus !== 'CLEAN' && document.scanStatus !== null">
            <input *ngIf="!multiple" name="selectedDocument" type="radio" (click)="selectedDocument = document" [disabled]="document.scanStatus !== 'CLEAN' && document.scanStatus !== null">
            <i class="icon-16-doc-{{ document.icon }}"></i>
            <span class="doc-title">{{ document.title }}</span>
          </label>
        </li>
        <li class="no-docs" *ngIf="!documents || documents.length <= 0">
          No documents found!<br/>Click on the documents tab to add some
        </li>
      </div>

      <div *ngIf="documents && documents.length >= 1" class="footer doc-attach-footer">
        <div class="footer doc-attach-footer">
          <a class="pointer inline-block" (click)="cancel()">Cancel</a>
          <button class="btn btn-xs btn-action btn-primary inline-block"
                  (click)="submit()"
                  data-ls-disable="!someChecked()">
            Attach
          </button>
        </div>
      </div>
    </ul>

  </div>
